var exports = {
  "kL": "xe533113f--029883--container",
  "wx": "xe533113f--029883--header",
  "iW": "xe533113f--029883--main",
  "RR": "xe533113f--029883--listing",
  "tp": "xe533113f--029883--table",
  "x": "xe533113f--029883--offer",
};

module.exports = exports;
